import { getToday } from '@/common/functions/getToday';
import { useRef, useState } from 'react';

const useSearchBox = ({ handleSearchCallback }) => {
	const today = getToday();

	const dateFromRef = useRef();
	const dateToRef = useRef();

	const [selectedDomain, setSelectedDomain] = useState();
	const [selectedTest, setSelectedTest] = useState();
	const [selectedCompareSource, setSelectedCompareSource] = useState();
	const [selectedCompareTo, setSelectedCompareTo] = useState();

	const handleSearch = (e) => {
		e.preventDefault();
		const browserPersonDayFrom = new Date(
			dateFromRef.current.value,
		).toISOString();
		const browserPersonDayTo = new Date(dateToRef.current.value).toISOString();
		const domain = selectedDomain?.value;
		const test = selectedTest.value;
		const compareSource = selectedCompareSource.value;
		const compareTo = selectedCompareTo.value;

		handleSearchCallback(
			browserPersonDayFrom,
			browserPersonDayTo,
			domain,
			test,
			compareSource,
			compareTo,
		);
	};

	return {
		today,
		dateFromRef,
		dateToRef,
		handleSearch,
		selectedDomain,
		setSelectedDomain,
		selectedTest,
		setSelectedTest,
		selectedCompareSource,
		setSelectedCompareSource,
		selectedCompareTo,
		setSelectedCompareTo,
	};
};

export default useSearchBox;
